import {isMobile} from "react-device-detect";
import {useMemo, useState} from "react";
import {useSelector} from "react-redux";
import {DashboardLayout} from "components/Layout";
import {BasicTable, SearchBox} from "components/Table";
import {ModalConfirmation} from "components/Modal";
import {ToggleSwitch} from "components/Button";
import {useListPositionById, useChangeDataStatus} from "hooks/AdminHospital/Position";
import {useToast} from "hooks/useToast";
import {useStateCallback} from "hooks/useStateCallback";
import {convertErrorMessageFormat} from "utils/converter";
import {handleSort} from "utils/sort";

export function HospitalListPositionPage() {
	const selectedHospital = useSelector(state => state.HospitalsReducer.selectedHospital);
	const [searchKeyword, setSearchKeyword] = useState("");
	const [dataFilter, setDataFilter] = useState({page: 1, limit: 10, search: ""});
	const {data, isLoading} = useListPositionById({...dataFilter, hospitalId: selectedHospital.Hospital.id});

	// Delete Data State
	const {mutate, isLoading: isUpdatingData} = useChangeDataStatus();
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [selectedItem, setSelectedItem] = useStateCallback({id: null, name: null});
	const {showToast} = useToast();

	const columns = useMemo(
		() => [
			{
				Header: "Nama Jabatan",
				accessor: "name",
				Cell: ({row}) => {
					return row.original?.name || "";
				},
			},
			{
				centered: true,
				Header: "Aksi",
				accessor: "isActive",
				width: "200px",
				Cell: ({row}) => {
					return (
						<>
							<ToggleSwitch
								isActive={row.original.isActive}
								onChange={() => {
									setSelectedItem({...row?.original, status: row.original.isActive}, () =>
										setShowDeleteModal(true),
									);
								}}
							/>
						</>
					);
				},
				sortType: handleSort,
			},
		],
		[setSelectedItem],
	);
	const columnsMobile = useMemo(
		() => [
			{
				Header: "Nama Jabatan",
				accessor: "name",
				Cell: ({row}) => {
					return (
						<div class="col-6">
							<div class="text-bold">{row.original?.name}</div>
						</div>
					);
				},
			},
			{
				Header: "Aksi",
				accessor: "isActive",
				Cell: ({row}) => {
					return (
						<div className="col-6">
							<>
								<ToggleSwitch
									isActive={row.original.isActive}
									onChange={() => {
										setSelectedItem({...row?.original}, () => setShowDeleteModal(true));
									}}
								/>
							</>
						</div>
					);
				},
				sortType: handleSort,
			},
		],
		[setSelectedItem],
	);

	const handeChangeStatusItem = () => {
		mutate(
			{positionId: selectedItem.id, hospitalId: selectedHospital.hospitalId},
			{
				onSuccess: () => {
					showToast(
						"success",
						`Data Jabatan "${selectedItem.name}" berhasil di ${
							selectedItem.status ? "non-aktifkan" : "aktifkan"
						}`,
						3000,
					);
					window.scrollTo(0, 0);
					setShowDeleteModal(false);
					setSelectedItem({id: null, name: null});
				},
				onError: res => {
					showToast("error", convertErrorMessageFormat(res.response.status, res.response.data.message), null);
				},
			},
		);
	};

	return (
		<DashboardLayout>
			<>
				<ModalConfirmation
					approveLabel="Ya"
					description={`Apakah Anda yakin ingin  ${
						selectedItem.status ? "non-aktifkan" : "aktifkan"
					} data jabatan "${selectedItem.name}"?`}
					loading={isUpdatingData}
					rejectLabel="Batal"
					visible={showDeleteModal}
					onApprove={handeChangeStatusItem}
					onClose={() => setShowDeleteModal(false)}
					onReject={() => setShowDeleteModal(false)}
				/>
				<div class="text-bold text-dark mb-4">{`Data Jabatan - ${selectedHospital.Hospital.name}`}</div>
				<SearchBox
					onSearch={keyword => {
						setSearchKeyword(keyword);
						setDataFilter(prevState => ({...prevState, page: 1, search: keyword}));
					}}
				/>

				<BasicTable
					columns={isMobile ? columnsMobile : columns}
					currentPage={data?.data?.currentPage}
					data={data?.data?.rows || []}
					disableSortBy={false}
					limit={dataFilter.limit}
					loading={isLoading}
					striped={true}
					title="Data Jabatan"
					totalItems={data?.data?.totalItems}
					totalPage={data?.data?.totalPages}
					onLimitChange={limitValue => {
						setDataFilter(prevState => ({...prevState, limit: limitValue, page: 1, search: searchKeyword}));
					}}
					onPageChange={selectedPage => setDataFilter(prevState => ({...prevState, page: selectedPage}))}
				/>
			</>
		</DashboardLayout>
	);
}
